module.exports = __webpack_public_path__ + "img/kosciol2.21ff069c.jpg";